import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaComponent } from './ad/da.component';
import { ImgResizeModule } from "../img-resize/img-resize.module";
import { KzIconsModule } from "../../../kz-ui/ui/icon/kz-icons.module";
import { GtmTrackModule } from "../../../utils/directives/gtm-track/gtm-track.module";
import { DasService } from "./das.service";
import { DaLocationComponent } from './da-location/da-location.component';
import { ConcatUserIdPipe } from "../../../utils/pipes/concat-user-id.pipe";
import { AbTestComponent } from "../../../utils/directives/ab-test/ab-test.component";
import { AbTestItemDirective } from "../../../utils/directives/ab-test/ab-test-item.directive";



@NgModule({
  declarations: [
    DaComponent,
    DaLocationComponent,
  ],
  imports: [
    CommonModule,
    ImgResizeModule,
    KzIconsModule,
    GtmTrackModule,
    ConcatUserIdPipe,
    AbTestComponent,
    AbTestItemDirective,
  ],
  exports: [
    DaLocationComponent,
  ],
  providers: [
    DasService,
  ]
})
export class DasModule { }
